import { Component, OnInit, Inject, ViewChild  } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators,AbstractControl,NgModel, NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import {MigrationConfigComponentServices} from 'src/app/shared/services/Migrationconfiguration';
import { MatSnackBar } from "@angular/material/snack-bar";
import { NgxUiLoaderService } from "ngx-ui-loader";

export interface FormData {
  rowData: any; // Ensure migrationId is inside rowData
  isEdit: boolean;
}

@Component({
    selector: 'app-migration-configpopup',
    templateUrl: './migration-configpopup.component.html',
    styleUrls: ['./migration-configpopup.component.scss'],
    standalone: false
})
export class MigrationConfigpopupComponent implements OnInit {

  formValid: UntypedFormGroup;
  inputValue: string = '';
  GlobalExtraction: string = '';
  Extraction: string = '';
  Transform: string = '';
  Load: string = '';
  Validation: string = '';
  createdBy: string = '';
  createdDate: string = '';
  lastModifiedBy: string = '';
  lastModifiedDate: string = '';
  tenantId : string = '';
  status : string = '';
  currentTime : any;
  buttonText: string = 'Save';
  backgroundColorButton: string = '';
  isCheckboxSelected: boolean = false;
  submitted = false;
  isRequired = true;
  backgroundColorButton2: string = '';

  isAddingRecord=true;

  constructor(
    public dialogRef: MatDialogRef<MigrationConfigpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FormData,
    private localStorageSettings: LocalStorageSettingsService,
    private migrationconfigservices: MigrationConfigComponentServices,
    private snackbar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    
  ) {}
  

  

  ngOnInit(): void {
    console.log(this.data);
    this.isAddingRecord = !this.data.isEdit;
   

    // Ensure data is valid before accessing migrationId
    if (this.data?.rowData?.migrationId) {
      this.inputValue = this.data.rowData.migrationId;
      this.GlobalExtraction = this.data.rowData.globalextractionduration;
      this.Extraction = this.data.rowData.extractionDuration;
      this.Transform =  this.data.rowData.transformationDuration;
      this.Load      =  this.data.rowData.loadDuration;
      this.Validation=  this.data.rowData.validationDuration;
      this.createdBy= this.data.rowData.createdBy;
      this.createdDate = this.data.rowData.createdDate;
      this.lastModifiedBy = this.data.rowData.lastModifiedBy;
      this.lastModifiedDate = this.data.rowData.lastModifiedDate;
      this.tenantId = this.data.rowData.tenantId;
      this.status = this.data.rowData.status;
      this.buttonText = 'Update';
    }
    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
    this.backgroundColorButton2=this.localStorageSettings.getSettings("ColorD");
    // Fetch the current time in 'HH:MM' format
    const currentDate = new Date().toISOString().split('T')[0];
     this.currentTime = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }

  async onSubmit(form:NgForm) {
    
    this.submitted = true;
    form.form.markAllAsTouched(); // <-- This is important!
  // await new Promise(resolve => setTimeout(resolve, 0));
    if (form.valid) {
      
      console.log('Form Submitted', form.value);
     this.updateData(form.value);
      // if(res === undefined){
      //   console.warn('updateData() returned undefined');
      //   // e.g., show an error snackbar
      //   this.snackbar.open('Something went wrong. Please try again.', 'OK', { duration: 3000 });
      // }
    } else {
      this.snackbar.open('All Mandatory fields to be filled', 'OK', { duration: 3000 });
    }
  } 
  async updateData(values: any) {
    const {
      inputValue,
      GlobalExtraction,
      Extraction,
      Transform,
      Load,
      Validation,
      createdBy,
      createdDate,
      lastModifiedBy,
      lastModifiedDate,
      tenantId,
      status
    } = values;
    if (
      Number(inputValue) <= 0 ||
      Number(GlobalExtraction) <= 0 ||
      Number(Extraction) <= 0 ||
      Number(Transform) <= 0 ||
      Number(Load) <= 0 ||
      Number(Validation) <= 0
    ) {
      //console.log(this.Extraction+"--"+this.GlobalExtraction+"---"+this.Extraction+"--"+this.Load+"--"+this.Validation)
      this.snackbar.open("Values must be greater than 0.", "OK", { duration: 5000 });
      return;
    }
    
    let res;
    const requestData = {
      migrationId: inputValue,
      globalextractionduration: GlobalExtraction,
      extractionDuration: Extraction,
      transformationDuration: Transform,
      loadDuration: Load,
      validationDuration: Validation,
      createdBy: createdBy,
      createdDate: createdDate,
      lastModifiedBy: lastModifiedBy,
      lastModifiedDate: lastModifiedDate,
      tenantId: tenantId,
      status: status
    };

    console.log(requestData)

    if(this.buttonText === 'Update'){
      this.isAddingRecord=false;
      this.spinner.start()
      this.submitted = false;
      requestData.lastModifiedBy = this.localStorageSettings.getSettings("AuthUsername");
      requestData.lastModifiedDate = this.currentTime;
      requestData.tenantId=this.localStorageSettings.getSettings("dnsName");
      requestData.status = requestData.status == null ? 'Yes' : requestData.status;
      console.log(requestData)

      res =await this.migrationconfigservices.insertMigrationConfigComponentinfoData(requestData,'Update').subscribe(res => { 
        console.log(res)
        
        this.snackbar.open(res.data, "OK", { duration: 5000,});
        this.spinner.stop()
        this.handlePostSubmit();
        
      });

        

        
    }
    else{
      //means create checkbox is visible and dialog does not close when click on save, only snackbar shows
     // this.isAddingRecord=false;
      this.spinner.start()
      this.submitted = false;
      requestData.createdBy = this.localStorageSettings.getSettings("AuthUsername");
      requestData.createdDate = null;
      requestData.tenantId = this.localStorageSettings.getSettings("dnsName");
      requestData.lastModifiedBy = null;
      requestData.lastModifiedDate = null;
      requestData.status = 'Yes';
      console.log(requestData)

      res = await this.migrationconfigservices.insertMigrationConfigComponentinfoData(requestData,'Save').subscribe(res => { 
        console.log(res)
        
        this.snackbar.open(res.data, "OK", { duration: 5000,});
        this.spinner.stop()
        this.handlePostSubmit();
        
        
      });
    }
  this.submitted = false;
  return;
  }

  close(): void {
    this.dialogRef.close();
  }



  handlePostSubmit(): void {
    if (this.isCheckboxSelected) {
      this.resetFormFields();
      this.setRequiredAfterDelay();
    } else {
      this.dialogRef.close('Inserted');
    }
  }




  resetFormFields(): void {
    this.inputValue = '';
    this.GlobalExtraction = '';
    this.Extraction = '';
    this.Transform = '';
    this.Load = '';
    this.Validation = '';
    this.createdBy = '';
    this.createdDate = '';
    this.lastModifiedBy = '';
    this.lastModifiedDate = '';
    this.tenantId = '';
    this.status = '';
    this.isCheckboxSelected = false;
    this.isRequired = false;
  }


  async setRequiredAfterDelay() {
    console.log('Waiting for 10 seconds...');
    
    await this.delay(7000);
    
    // After the delay, set isRequired to true
  //  this.isRequired = true;
    console.log('isRequired set to:', this.isRequired);
  }

  delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
